/// When adding a new tracking function, make sure you add the key to the Tracking Key object and add tracking details to notion
/// https://www.notion.so/raisework/Segment-Analytics-210b3dbd296146c58e5135c083ad588d

import { deprecatedTrackEvent } from "./SegmentHelpers";
import { TrackingEventNames, TrackingEventTypes } from "./TrackingConstants";
export var trackOpenFiltersModal = function trackOpenFiltersModal(params) {
  deprecatedTrackEvent(TrackingEventNames.OPEN_FILTERS_MODAL, TrackingEventTypes.BUTTON_PRESS, params);
};
export var trackFilterApplication = function trackFilterApplication(params) {
  deprecatedTrackEvent(TrackingEventNames.APPLY_FILTERS, TrackingEventTypes.BUTTON_PRESS, params);
};
export var trackAddListingToDealroom = function trackAddListingToDealroom(params) {
  deprecatedTrackEvent(TrackingEventNames.ADD_LISTING_TO_DEALROOM, TrackingEventTypes.DEALROOM_ACTION, params);
};